import { parseAccountsForFeature } from '@/assets/scripts/parsers/accounts'

/** saves the account list in our store
@payload { array } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_accounts
*/
export const SAVE_ACCOUNTS_LIST = (state, payload) => {
    const parsedAccounts = parseAccountsForFeature(payload.bankAccountView).map(account => {
        return {
            ...account,
            id: account.id,
            accountName: account.description,
            accountNumber: account.accountNumber,
            accountBalance: account.balance,
            accountCurrency: account.currency,
            default: account.default
        }
    })

    state.accountsList = parsedAccounts
}

/** saves the financial plan list in our store
@payload { array } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_financialplan
*/
export const SAVE_FINANCIAL_PLAN = (state, { maturityDate, data }) => {
    state.financialPlan = data
    state.financialPlanList = maturityDate ? state.financialPlanList.concat(data.financialPlan) : data.financialPlan

    state.financialPlanHasMore = data.hasMore
}

/** saves a list of movements
@payload { array }
*/
export const SAVE_MOVEMENTS = (state, { pageNumber, data }) => {
    state.movements = pageNumber === 1 ? data.movements : state.movements.concat(data.movements)

    state.lastMovementInfo = {
        releaseDatePosition: data.releaseDatePosition,
        orderNumberPosition: data.orderNumberPosition
    }
    state.movementsHasMore = data.hasMore
}

/** saves Accounts List
@payload {Object} with:
    accountId {Number} - accountId for which we changed the description
    data {Object} - object with new account description
*/
export const SAVES_NEW_ACCOUNT_DESCRIPTION = (state, { payload, responseData }) => {
    state.accountsList = state.accountsList.map(account => {
        return {
            ...account,
            description: account.id === payload.accountId ? responseData.description : account.description
        }
    })
}

/* ***********************************************
*                  CLEAR MUTATIONS               *
*********************************************** */
export const CLEAR_FEATURE_STATE = (state, payload) => {
    state.accountsList = []
    state.financialPlan = []
    state.movements = []
    state.lastMovementInfo = {}
    state.movementsHasMore = false
    state.financialPlanHasMore = false
}
